const translationKeys = {
  paymentagreements_agreement_type_list_title:
    'paymentagreements_agreement_type_list_title',
  paymentagreements_einvoice_title: 'paymentagreements_einvoice_title',
  paymentagreements_direct_debit_title: 'paymentagreements_direct_debit_title',
  paymentagreements_standing_orders_title:
    'paymentagreements_standing_orders_title',
  paymentagreements_subscriptions_title:
    'paymentagreements_subscriptions_title',
  paymentagreements_einvoice_description:
    'paymentagreements_einvoice_description',
  paymentagreements_digipost_invoice_description:
    'paymentagreements_digipost_invoice_description',
  paymentagreements_direct_debit_description:
    'paymentagreements_direct_debit_description',
  paymentagreements_standing_orders_description:
    'paymentagreements_standing_orders_description',
  paymentagreements_subscriptions_description:
    'paymentagreements_subscriptions_description',
  paymentagreements_proposal_description:
    'paymentagreements_proposal_description',
  paymentagreements_proposal_delete_button:
    'paymentagreements_proposal_delete_button',
  paymentagreements_proposal_add_einvoice_button:
    'paymentagreements_proposal_add_einvoice_button',
  paymentagreements_einvoice_always_einvoice_label:
    'paymentagreements_einvoice_always_einvoice_label',
  paymentagreements_einvoice_info_and_conditions:
    'paymentagreements_einvoice_info_and_conditions',
  paymentagreements_suggested_agreements_title:
    'paymentagreements_suggested_agreements_title',
  paymentagreements_existing_agreements_title:
    'paymentagreements_existing_agreements_title',
  paymentagreements_add_new_agreement_text:
    'paymentagreements_add_new_agreement_text',
  paymentagreements_digipost_invoice_details_toggler_label:
    'paymentagreements_digipost_invoice_details_toggler_label',
  paymentagreements_digipost_invoice_details_toggler_description:
    'paymentagreements_digipost_invoice_details_toggler_description',
  paymentagreements_digipost_invoice_terms_and_conditions_label:
    'paymentagreements_digipost_invoice_terms_and_conditions_label',
  paymentagreements_add_agreement_recipient_list_label:
    'paymentagreements_add_agreement_recipient_list_label',
  paymentagreements_add_agreement_recipient_list_placeholder:
    'paymentagreements_add_agreement_recipient_list_placeholder',
  paymentagreements_add_agreement_description_input_label:
    'paymentagreements_add_agreement_description_input_label',
  paymentagreements_add_agreement_description_input_placeholder:
    'paymentagreements_add_agreement_description_input_placeholder',
  paymentagreements_add_agreement_from_account_label:
    'paymentagreements_add_agreement_from_account_label',
  paymentagreements_add_agreement_from_account_placeholder:
    'paymentagreements_add_agreement_from_account_placeholder',
  paymentagreements_add_agreement_max_monthly_limit_input_label:
    'paymentagreements_add_agreement_max_monthly_limit_input_label',
  paymentagreements_add_agreement_max_monthly_limit_input_placeholder:
    'paymentagreements_add_agreement_max_monthly_limit_input_placeholder',
  paymentagreements_add_agreement_max_monthly_limit_message:
    'paymentagreements_add_agreement_max_monthly_limit_message',
  paymentagreements_add_agreement_pick_date_input_label:
    'paymentagreements_add_agreement_pick_date_input_label',
  paymentagreements_add_agreement_recurring_amount_input_label:
    'paymentagreements_add_agreement_recurring_amount_input_label',
  paymentagreements_add_agreement_recurring_amount_input_placeholder:
    'paymentagreements_add_agreement_recurring_amount_input_placeholder',
  paymentagreements_add_agreement_button_text:
    'paymentagreements_add_agreement_button_text',
  paymentagreements_add_agreement_recurring_payment_header:
    'paymentagreements_add_agreement_recurring_payment_header',
  paymentagreements_header_title: 'paymentagreements_header_title',
  paymentagreements_transfer_agreements_heading:
    'paymentagreements_transfer_agreements_heading',
  paymentagreements_subscription_details_tab_name:
    'paymentagreements_subscription_details_tab_name',
  paymentagreements_subscription_payment_history_tab_name:
    'paymentagreements_subscription_payment_history_tab_name',
  paymentagreements_remove_subscription_button_label:
    'paymentagreements_remove_subscription_button_label',
  paymentagreements_cancel_button_label:
    'paymentagreements_cancel_button_label',
  paymentagreements_remove_subscription_confirm_button_text:
    'paymentagreements_remove_subscription_confirm_button_text',
  paymentagreements_no_payments_subscription_found_message:
    'paymentagreements_no_payments_subscription_found_message',
  paymentagreements_proposal_add_direct_debit_button:
    'paymentagreements_proposal_add_direct_debit_button',
  paymentagreements_add_agreement_ref_number_input_label:
    'paymentagreements_add_agreement_ref_number_input_label',
  paymentagreements_add_agreement_ref_number_input_placeholder:
    'paymentagreements_add_agreement_ref_number_input_placeholder',
  paymentagreements_digipost_invoice_title:
    'paymentagreements_digipost_invoice_title',
  paymentagreements_subscription_frequency_weekly:
    'paymentagreements_subscription_frequency_weekly',
  paymentagreements_subscription_frequency_biweekly:
    'paymentagreements_subscription_frequency_biweekly',
  paymentagreements_subscription_frequency_monthly:
    'paymentagreements_subscription_frequency_monthly',
  paymentagreements_subscription_frequency_bimonthly:
    'paymentagreements_subscription_frequency_bimonthly',
  paymentagreements_subscription_frequency_quarterly:
    'paymentagreements_subscription_frequency_quarterly',
  paymentagreements_subscription_frequency_half_yearly:
    'paymentagreements_subscription_frequency_half_yearly',
  paymentagreements_subscription_frequency_yearly:
    'paymentagreements_subscription_frequency_yearly',
  paymentagreements_subscription_no_payment_transactions_found:
    'paymentagreements_subscription_no_payment_transactions_found',
  paymentagreements_subscription_subscription_payment_history_error:
    'paymentagreements_subscription_subscription_payment_history_error',
  paymentagreements_remove_subscription_confirm_message:
    'paymentagreements_remove_subscription_confirm_message',
  paymentagreements_subscription_subscription_list_error:
    'paymentagreements_subscription_subscription_list_error',
  paymentagreements_subscription_no_subscriptions_found:
    'paymentagreements_subscription_no_subscriptions_found',
  paymentagreements_subscription_fetch_accounts_error:
    'paymentagreements_subscription_fetch_accounts_error',
  paymentagreements_subscription_fetch_subscription_details_error:
    'paymentagreements_subscription_fetch_subscription_details_error',
  paymentagreements_agreements_list_error:
    'paymentagreements_agreements_list_error',
  paymentagreements_account_list_fetch_error:
    'paymentagreements_account_list_fetch_error',
  paymentagreements_agreement_proposal_details_fetch_error:
    'paymentagreements_agreement_proposal_details_fetch_error',
  paymentagreements_standing_orders_recipients_fetch_error:
    'paymentagreements_standing_orders_recipients_fetch_error',
  paymentagreements_standing_orders_no_standing_orders_found:
    'paymentagreements_standing_orders_no_standing_orders_found',
  paymentagreements_standing_order_frequency_weekly:
    'paymentagreements_standing_order_frequency_weekly',
  paymentagreements_standing_order_frequency_fortnightly:
    'paymentagreements_standing_order_frequency_fortnightly',
  paymentagreements_standing_order_frequency_monthly:
    'paymentagreements_standing_order_frequency_monthly',
  paymentagreements_standing_order_frequency_bi_monthly:
    'paymentagreements_standing_order_frequency_bi_monthly',
  paymentagreements_standing_order_frequency_quarterly:
    'paymentagreements_standing_order_frequency_quarterly',
  paymentagreements_standing_order_frequency_semi_annual:
    'paymentagreements_standing_order_frequency_semi_annual',
  paymentagreements_standing_order_frequency_annual:
    'paymentagreements_standing_order_frequency_annual',
  paymentagreements_standing_order_frequency_daily:
    'paymentagreements_standing_order_frequency_daily',
  paymentagreements_standing_order_frequency_semi_monthly:
    'paymentagreements_standing_order_frequency_semi_monthly',
  paymentagreements_standing_order_frequency_tertiarly:
    'paymentagreements_standing_order_frequency_tertiarly',
  paymentagreements_recurring_payment: 'paymentagreements_recurring_payment',
  paymentagreements_recurring_transfer: 'paymentagreements_recurring_transfer',
  paymentagreements_subscription_expected_next_payment_message:
    'paymentagreements_subscription_expected_next_payment_message',
  paymentagreements_agreement_list_status_invalid:
    'paymentagreements_agreement_list_status_invalid',
  paymentagreements_agreement_list_status_pending:
    'paymentagreements_agreement_list_status_pending',
  paymentagreements_agreement_list_status_suspended:
    'paymentagreements_agreement_list_status_suspended',
  paymentagreements_standing_order_agreement_details_tab_name:
    'paymentagreements_standing_order_agreement_details_tab_name',
  paymentagreements_standing_order_payment_history_tab_name:
    'paymentagreements_standing_order_payment_history_tab_name',
  paymentagreements_standing_order_transfer_history_tab_name:
    'paymentagreements_standing_order_transfer_history_tab_name',
  paymentagreements_standing_order_details_fetch_error:
    'paymentagreements_standing_order_details_fetch_error',
  paymentagreements_standing_order_agreement_details_next_payment:
    'paymentagreements_standing_order_agreement_details_next_payment',
  paymentagreements_standing_order_agreement_details_next_transfer:
    'paymentagreements_standing_order_agreement_details_next_transfer',
  paymentagreements_standing_order_agreement_details_created:
    'paymentagreements_standing_order_agreement_details_created',
  paymentagreements_standing_order_agreement_details_cid:
    'paymentagreements_standing_order_agreement_details_cid',
  paymentagreements_standing_order_agreement_details_message:
    'paymentagreements_standing_order_agreement_details_message',
  paymentagreements_standing_order_agreement_details_paid_from:
    'paymentagreements_standing_order_agreement_details_paid_from',
  paymentagreements_standing_order_agreement_details_repeated_frequency_text:
    'paymentagreements_standing_order_agreement_details_repeated_frequency_text',
  paymentagreements_standing_order_agreement_details_edit_button:
    'paymentagreements_standing_order_agreement_details_edit_button',
  paymentagreements_standing_order_agreement_details_delete_button:
    'paymentagreements_standing_order_agreement_details_delete_button',
  paymentagreements_standing_order_details_fetch_accounts_error:
    'paymentagreements_standing_order_details_fetch_accounts_error',
  paymentagreements_standing_order_delete_agreement_heading:
    'paymentagreements_standing_order_delete_agreement_heading',
  paymentagreements_standing_order_delete_recurring_payment_description:
    'paymentagreements_standing_order_delete_recurring_payment_description',
  paymentagreements_standing_order_delete_recurring_transfer_description:
    'paymentagreements_standing_order_delete_recurring_transfer_description',
  paymentagreements_standing_order_delete_agreement_confirm_button:
    'paymentagreements_standing_order_delete_agreement_confirm_button',
  paymentagreements_standing_order_delete_recurring_payment_success_text:
    'paymentagreements_standing_order_delete_recurring_payment_success_text',
  paymentagreements_standing_order_delete_recurring_transfer_success_text:
    'paymentagreements_standing_order_delete_recurring_transfer_success_text',
  paymentagreements_subscription_remove_success_message:
    'paymentagreements_subscription_remove_success_message',
  paymentagreements_standing_order_agreement_details_from_account_label:
    'paymentagreements_standing_order_agreement_details_from_account_label',
  paymentagreements_standing_order_agreement_details_frequency_selector_label:
    'paymentagreements_standing_order_agreement_details_frequency_selector_label',
  paymentagreements_standing_order_agreement_details_save_button:
    'paymentagreements_standing_order_agreement_details_save_button',
  paymentagreements_standing_order_agreement_details_stop_date:
    'paymentagreements_standing_order_agreement_details_stop_date',
  paymentagreements_standing_order_edit_frequency_is_required_error:
    'paymentagreements_standing_order_edit_frequency_is_required_error',
  paymentagreements_standing_order_edit_amount_is_required_error:
    'paymentagreements_standing_order_edit_amount_is_required_error',
  paymentagreements_standing_order_edit_message_max_length_error:
    'paymentagreements_standing_order_edit_message_max_length_error',
  paymentagreements_standing_order_edit_account_is_required_error:
    'paymentagreements_standing_order_edit_account_is_required_error',
  paymentagreements_standing_order_agreement_edit_feedback_error_title:
    'paymentagreements_standing_order_agreement_edit_feedback_error_title',
  paymentagreements_standing_order_agreement_edit_feedback_error_subtitle:
    'paymentagreements_standing_order_agreement_edit_feedback_error_subtitle',
  paymentagreements_standing_order_agreement_edit_feedback_error_try_again_button:
    'paymentagreements_standing_order_agreement_edit_feedback_error_try_again_button',
  paymentagreements_standing_order_recurring_payment_edit_feedback_success_title:
    'paymentagreements_standing_order_recurring_payment_edit_feedback_success_title',
  paymentagreements_standing_order_recurring_transfer_edit_feedback_success_title:
    'paymentagreements_standing_order_recurring_transfer_edit_feedback_success_title',
  paymentagreements_ocr_validation_rules_fetch_error:
    'paymentagreements_ocr_validation_rules_fetch_error',
  paymentagreements_standing_order_edit_cid_required:
    'paymentagreements_standing_order_edit_cid_required',
  paymentagreements_standing_order_list_error_title:
    'paymentagreements_standing_order_list_error_title',
  paymentagreements_standing_order_list_error_message:
    'paymentagreements_standing_order_list_error_message',
  paymentagreements_subscription_list_error_title:
    'paymentagreements_subscription_list_error_title',
  paymentagreements_subscription_list_error_message:
    'paymentagreements_subscription_list_error_message',
  paymentagreements_subscription_payment_history_error_title:
    'paymentagreements_subscription_payment_history_error_title',
  paymentagreements_subscription_payment_history_error_message:
    'paymentagreements_subscription_payment_history_error_message',
  paymentagreements_einvoice_info_section_content_heading:
    'paymentagreements_einvoice_info_section_content_heading',
  paymentagreements_einvoice_info_section_content_text:
    'paymentagreements_einvoice_info_section_content_text',
  paymentagreements_einvoice_issuer_list_title:
    'paymentagreements_einvoice_issuer_list_title',
  paymentagreements_einvoice_issuer_list_description:
    'paymentagreements_einvoice_issuer_list_description',
  paymentagreements_einvoice_issuer_list_error_title:
    'paymentagreements_einvoice_issuer_list_error_title',
  paymentagreements_einvoice_issuer_list_error_message:
    'paymentagreements_einvoice_issuer_list_error_message',
  paymentagreements_blocked_einvoice_issuer_title:
    'paymentagreements_blocked_einvoice_issuer_title',
  paymentagreements_no_einvoice_issuers_present_message:
    'paymentagreements_no_einvoice_issuers_present_message',
  paymentagreements_einvoice_include_other_banks_title:
    'paymentagreements_einvoice_include_other_banks_title',
  paymentagreements_einvoice_include_other_banks_description:
    'paymentagreements_einvoice_include_other_banks_description',
  paymentagreements_blocked_einvoice_issuer_list_title:
    'paymentagreements_blocked_einvoice_issuer_list_title',
  paymentagreements_blocked_einvoice_issuer_list_description:
    'paymentagreements_blocked_einvoice_issuer_list_description',
  paymentagreements_einvoice_always_einvoice_agreement_is_off_warning_message:
    'paymentagreements_einvoice_always_einvoice_agreement_is_off_warning_message',
  paymentagreements_standing_order_list_beneficiary_name:
    'paymentagreements_standing_order_list_beneficiary_name',
  paymentagreements_subscription_list_subscription_provider_name:
    'paymentagreements_subscription_list_subscription_provider_name',
  paymentagreements_einvoice_block_issuer:
    'paymentagreements_einvoice_block_issuer',
  paymentagreements_einvoice_issuer_history_error:
    'paymentagreements_einvoice_issuer_history_error',
  paymentagreements_einvoice_issuer_history_error_message:
    'paymentagreements_einvoice_issuer_history_error_message',
  paymentagreements_einvoice_issuer_details_error_in_history:
    'paymentagreements_einvoice_issuer_details_error_in_history',
  paymentagreements_einvoice_issuer_history_credit_note:
    'paymentagreements_einvoice_issuer_history_credit_note',
  paymentagreements_einvoice_issuer_history_awaiting_approval:
    'paymentagreements_einvoice_issuer_history_awaiting_approval',
  paymentagreements_einvoice_issuer_history_direct_debit_combo:
    'paymentagreements_einvoice_issuer_history_direct_debit_combo',
  paymentagreements_einvoice_issuer_history_approved:
    'paymentagreements_einvoice_issuer_history_approved',
  paymentagreements_einvoice_issuer_history_deleted:
    'paymentagreements_einvoice_issuer_history_deleted',
  paymentagreements_einvoice_issuer_history_deleted_in_bank:
    'paymentagreements_einvoice_issuer_history_deleted_in_bank',
  paymentagreements_einvoice_issuer_history_approved_in_bank:
    'paymentagreements_einvoice_issuer_history_approved_in_bank',
  paymentagreements_einvoice_issuer_history_new_due_date_approved_info_message:
    'paymentagreements_einvoice_issuer_history_new_due_date_approved_info_message',
  paymentagreements_einvoice_issuer_history_new_amount_approved_info_message:
    'paymentagreements_einvoice_issuer_history_new_amount_approved_info_message',
  paymentagreements_einvoice_issuer_history_approved_with_new_amount_and_date_info_message:
    'paymentagreements_einvoice_issuer_history_approved_with_new_amount_and_date_info_message',
  paymentagreements_einvoice_issuer_blocked_warning_message:
    'paymentagreements_einvoice_issuer_blocked_warning_message',
  paymentagreements_einvoice_switch_error_message:
    'paymentagreements_einvoice_switch_error_message',
  paymentagreements_issuer_einvoice_history_empty_message:
    'paymentagreements_issuer_einvoice_history_empty_message',
  paymentagreements_issuer_einvoice_history_dunning_message:
    'paymentagreements_issuer_einvoice_history_dunning_message',
  paymentagreements_issuer_einvoice_history_collection_notice_message:
    'paymentagreements_issuer_einvoice_history_collection_notice_message',
  paymentagreements_issuer_einvoice_history_reminder_message:
    'paymentagreements_issuer_einvoice_history_reminder_message',
  paymentagreements_issuer_einvoice_history_enforcement_warning_message:
    'paymentagreements_issuer_einvoice_history_enforcement_warning_message',
  paymentagreements_issuer_einvoice_history_payment_request_message:
    'paymentagreements_issuer_einvoice_history_payment_request_message',
  paymentagreements_always_einvoice_switch_error_message:
    'paymentagreements_always_einvoice_switch_error_message',
  paymentagreements_einvoice_my_einvoices_tab_label:
    'paymentagreements_einvoice_my_einvoices_tab_label',
  paymentagreements_einvoice_forwarded_einvoices_tab_label:
    'paymentagreements_einvoice_forwarded_einvoices_tab_label',
  paymentagreements_einvoice_forwarded_einvoices_title:
    'paymentagreements_einvoice_forwarded_einvoices_title',
  paymentagreements_einvoice_empty_forwarded_einvoices_message:
    'paymentagreements_einvoice_empty_forwarded_einvoices_message',
  paymentagreements_einvoice_forward_invoices_title:
    'paymentagreements_einvoice_forward_invoices_title',
  paymentagreements_einvoice_forward_cell_create_request_text:
    'paymentagreements_einvoice_forward_cell_create_request_text',
  paymentagreements_einvoice_forward_invoices_subtitle:
    'paymentagreements_einvoice_forward_invoices_subtitle',
  paymentagreements_ssn_field_label: 'paymentagreements_ssn_field_label',
  paymentagreements_einvoice_pending_invitations_section_title:
    'paymentagreements_einvoice_pending_invitations_section_title',
  paymentagreements_einvoice_pending_invitations_section_cell_description:
    'paymentagreements_einvoice_pending_invitations_section_cell_description',
  paymentagreements_einvoice_pending_invitations_reject_button:
    'paymentagreements_einvoice_pending_invitations_reject_button',
  paymentagreements_einvoice_pending_invitations_approve_button:
    'paymentagreements_einvoice_pending_invitations_approve_button',
  paymentagreements_einvoice_forwarded_einvoices_subtitle:
    'paymentagreements_einvoice_forwarded_einvoices_subtitle',
  paymentagreements_einvoice_forward_section_activated_date:
    'paymentagreements_einvoice_forward_section_activated_date',
  paymentagreements_einvoice_fetch_forward_einvoice_request_error_title:
    'paymentagreements_einvoice_fetch_forward_einvoice_request_error_title',
  paymentagreements_einvoice_fetch_forward_einvoice_request_error_message:
    'paymentagreements_einvoice_fetch_forward_einvoice_request_error_message',
  paymentagreements_forward_invoices_form_add_button:
    'paymentagreements_forward_invoices_form_add_button',
  paymentagreements_einvoice_pending_invitations_section_cell_error_message:
    'paymentagreements_einvoice_pending_invitations_section_cell_error_message',
  paymentagreements_einvoice_requested_forward_details_header_activated_date:
    'paymentagreements_einvoice_requested_forward_details_header_activated_date',
  paymentagreements_einvoice_requested_forward_details_remove_forward_section_title:
    'paymentagreements_einvoice_requested_forward_details_remove_forward_section_title',
  paymentagreements_einvoice_requested_forward_details_remove_forward_action_description:
    'paymentagreements_einvoice_requested_forward_details_remove_forward_action_description',
  paymentagreements_einvoice_requested_forward_details_remove_forward_action_button_text:
    'paymentagreements_einvoice_requested_forward_details_remove_forward_action_button_text',
  paymentagreements_einvoice_requested_forward_details_issuers_section_subtitle:
    'paymentagreements_einvoice_requested_forward_details_issuers_section_subtitle',
  paymentagreements_einvoice_pending_invitation_confirm_reject_title:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_title',
  paymentagreements_einvoice_pending_invitation_confirm_reject_subtitle:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_subtitle',
  paymentagreements_einvoice_pending_invitation_confirm_reject_cancel_button:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_cancel_button',
  paymentagreements_einvoice_pending_invitation_confirm_reject_confirmation_button:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_confirmation_button',
  paymentagreements_einvoice_pending_invitation_confirm_reject_error_try_again_button:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_error_try_again_button',
  paymentagreements_einvoice_pending_invitation_confirm_reject_error_title:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_error_title',
  paymentagreements_einvoice_pending_invitation_confirm_reject_error_subtitle:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_error_subtitle',
  paymentagreements_einvoice_pending_invitation_confirm_reject_loading_text:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_loading_text',
  paymentagreements_einvoice_pending_invitation_confirm_reject_success_message:
    'paymentagreements_einvoice_pending_invitation_confirm_reject_success_message',
  paymentagreements_einvoice_forward_cell_pending_request_text:
    'paymentagreements_einvoice_forward_cell_pending_request_text',
  paymentagreements_einvoice_forward_cell_active_request_text_activated_date:
    'paymentagreements_einvoice_forward_cell_active_request_text_activated_date',
  paymentagreements_einvoice_forward_cell_error_title:
    'paymentagreements_einvoice_forward_cell_error_title',
  paymentagreements_einvoice_forward_cell_error_message:
    'paymentagreements_einvoice_forward_cell_error_message',
  paymentagreements_einvoice_withdraw_forward_invitation_modal_confirm_title:
    'paymentagreements_einvoice_withdraw_forward_invitation_modal_confirm_title',
  paymentagreements_einvoice_withdraw_forward_invitation_modal_confirm_subtitle:
    'paymentagreements_einvoice_withdraw_forward_invitation_modal_confirm_subtitle',
  paymentagreements_einvoice_withdraw_forward_request_confirm_modal_loading_text:
    'paymentagreements_einvoice_withdraw_forward_request_confirm_modal_loading_text',
  paymentagreements_einvoice_withdraw_forward_request_modal_confirm_button:
    'paymentagreements_einvoice_withdraw_forward_request_modal_confirm_button',
  paymentagreements_einvoice_withdraw_forward_request_success_message:
    'paymentagreements_einvoice_withdraw_forward_request_success_message',
  paymentagreements_einvoice_withdraw_forward_request_modal_error_title:
    'paymentagreements_einvoice_withdraw_forward_request_modal_error_title',
  paymentagreements_einvoice_withdraw_forward_request_error_modal_subtitle:
    'paymentagreements_einvoice_withdraw_forward_request_error_modal_subtitle',
  paymentagreements_einvoice_withdraw_forward_request_modal_error_try_again_button:
    'paymentagreements_einvoice_withdraw_forward_request_modal_error_try_again_button',
  paymentagreements_einvoice_withdraw_forward_access_modal_confirm_title:
    'paymentagreements_einvoice_withdraw_forward_access_modal_confirm_title',
  paymentagreements_einvoice_withdraw_forward_access_modal_confirm_subtitle:
    'paymentagreements_einvoice_withdraw_forward_access_modal_confirm_subtitle',
  paymentagreements_einvoice_withdraw_pending_forward_request_button_text:
    'paymentagreements_einvoice_withdraw_pending_forward_request_button_text',
  paymentagreements_einvoice_withdraw_forward_request_modal_cancel_button:
    'paymentagreements_einvoice_withdraw_forward_request_modal_cancel_button',
  paymentagreements_einvoice_forward_invoices_terms_section_title:
    'paymentagreements_einvoice_forward_invoices_terms_section_title',
  paymentagreements_einvoice_forward_invoices_add_user_section_title:
    'paymentagreements_einvoice_forward_invoices_add_user_section_title',
  paymentagreements_einvoice_forward_invoices_submit_button:
    'paymentagreements_einvoice_forward_invoices_submit_button',
  paymentagreements_einvoice_forward_invoices_complete_terms_link_text:
    'paymentagreements_einvoice_forward_invoices_complete_terms_link_text',
  paymentagreements_einvoice_forward_invoices_terms_legal_text:
    'paymentagreements_einvoice_forward_invoices_terms_legal_text',
  paymentagreements_einvoice_forward_section_title:
    'paymentagreements_einvoice_forward_section_title',
  paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_confirm_title:
    'paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_confirm_title',
  paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_confirm_subtitle:
    'paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_confirm_subtitle',
  paymentagreements_einvoice_remove_received_forward_invitation_modal_error_title:
    'paymentagreements_einvoice_remove_received_forward_invitation_modal_error_title',
  paymentagreements_einvoice_remove_received_forward_invitation_modal_error_subtitle:
    'paymentagreements_einvoice_remove_received_forward_invitation_modal_error_subtitle',
  paymentagreements_einvoice_remove_received_forward_invitation_modal_error_try_again_button:
    'paymentagreements_einvoice_remove_received_forward_invitation_modal_error_try_again_button',
  paymentagreements_einvoice_remove_received_forward_invitation_modal_loading_text:
    'paymentagreements_einvoice_remove_received_forward_invitation_modal_loading_text',
  paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_confirm_button:
    'paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_confirm_button',
  paymentagreements_einvoice_remove_received_forward_invitation_success_title:
    'paymentagreements_einvoice_remove_received_forward_invitation_success_title',
  paymentagreements_einvoice_remove_received_forward_invitation_success_button_text:
    'paymentagreements_einvoice_remove_received_forward_invitation_success_button_text',
  paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_cancel_button:
    'paymentagreements_einvoice_confirm_remove_received_forward_invitation_modal_cancel_button',
  paymentagreements_einvoice_forward_invoices_submit_error_title:
    'paymentagreements_einvoice_forward_invoices_submit_error_title',
  paymentagreements_einvoice_forward_invoices_submit_error_subtitle:
    'paymentagreements_einvoice_forward_invoices_submit_error_subtitle',
  paymentagreements_einvoice_forward_invoices_success_notification_text:
    'paymentagreements_einvoice_forward_invoices_success_notification_text',
  paymentagreements_einvoice_disable_always_einvoice_modal_confirm_title:
    'paymentagreements_einvoice_disable_always_einvoice_modal_confirm_title',
  paymentagreements_einvoice_disable_always_einvoice_modal_confirm_subtitle:
    'paymentagreements_einvoice_disable_always_einvoice_modal_confirm_subtitle',
  paymentagreements_einvoice_disable_always_einvoice_modal_confirm_button_text:
    'paymentagreements_einvoice_disable_always_einvoice_modal_confirm_button_text',
  paymentagreements_einvoice_disable_always_einvoice_modal_cancel_button_text:
    'paymentagreements_einvoice_disable_always_einvoice_modal_cancel_button_text',
  paymentagreements_einvoice_disable_always_einvoice_modal_loading_text:
    'paymentagreements_einvoice_disable_always_einvoice_modal_loading_text',
  paymentagreements_einvoice_disable_always_einvoice_modal_error_title:
    'paymentagreements_einvoice_disable_always_einvoice_modal_error_title',
  paymentagreements_einvoice_disable_always_einvoice_modal_error_subtitle:
    'paymentagreements_einvoice_disable_always_einvoice_modal_error_subtitle',
  paymentagreements_einvoice_disable_always_einvoice_modal_error_try_again_button_text:
    'paymentagreements_einvoice_disable_always_einvoice_modal_error_try_again_button_text',
  paymentagreements_einvoice_disable_always_einvoice_with_pending_forward_invitation_modal_confirm_subtitle:
    'paymentagreements_einvoice_disable_always_einvoice_with_pending_forward_invitation_modal_confirm_subtitle',
  paymentagreements_einvoice_received_forward_einvoice_details_error_title:
    'paymentagreements_einvoice_received_forward_einvoice_details_error_title',
  paymentagreements_einvoice_received_forward_einvoice_details_error_subtitle:
    'paymentagreements_einvoice_received_forward_einvoice_details_error_subtitle',
  paymentagreements_einvoice_forward_invoices_ssn_error_message:
    'paymentagreements_einvoice_forward_invoices_ssn_error_message',
  paymentagreements_einvoice_accept_forward_invitation_success_message:
    'paymentagreements_einvoice_accept_forward_invitation_success_message',
  paymentagreements_einvoice_info_conditions_for_einvoice_consent_section_header:
    'paymentagreements_einvoice_info_conditions_for_einvoice_consent_section_header',
  paymentagreements_einvoice_info_conditions_for_einvoice_consent_section_content_text:
    'paymentagreements_einvoice_info_conditions_for_einvoice_consent_section_content_text',
  paymentagreements_einvoice_info_conditions_for_einvoice_consent_section_complete_terms_link_text:
    'paymentagreements_einvoice_info_conditions_for_einvoice_consent_section_complete_terms_link_text',
  paymentagreements_einvoice_withdraw_pending_forward_request_success_message:
    'paymentagreements_einvoice_withdraw_pending_forward_request_success_message',
  paymentagreements_breadcrumb_payment_agreements:
    'paymentagreements_breadcrumb_payment_agreements',
  paymentagreements_einvoice_my_info: 'paymentagreements_einvoice_my_info',
  paymentagreements_einvoice_my_info_contact_info_heading:
    'paymentagreements_einvoice_my_info_contact_info_heading',
  paymentagreements_einvoice_my_info_contact_info_description:
    'paymentagreements_einvoice_my_info_contact_info_description',
  paymentagreements_einvoice_my_info_reference_id_label:
    'paymentagreements_einvoice_my_info_reference_id_label',
  paymentagreements_einvoice_my_info_email_notification_section_title:
    'paymentagreements_einvoice_my_info_email_notification_section_title',
  paymentagreements_einvoice_my_info_email_notification_cell_title:
    'paymentagreements_einvoice_my_info_email_notification_cell_title',
  paymentagreements_mobile_phone_field_label:
    'paymentagreements_mobile_phone_field_label',
  paymentagreements_email_field_label: 'paymentagreements_email_field_label',
  paymentagreements_einvoice_my_info_contact_info_edit_button:
    'paymentagreements_einvoice_my_info_contact_info_edit_button',
  paymentagreements_einvoice_my_info_contact_info_save_button:
    'paymentagreements_einvoice_my_info_contact_info_save_button',
  paymentagreements_einvoice_include_other_banks_switch_error_message:
    'paymentagreements_einvoice_include_other_banks_switch_error_message',
  paymentagreements_direct_debit_agreement_list_empty_state_message:
    'paymentagreements_direct_debit_agreement_list_empty_state_message',
  paymentagreements_direct_debit_amount_monthly_limit_text:
    'paymentagreements_direct_debit_amount_monthly_limit_text',
  paymentagreements_direct_debit_from: 'paymentagreements_direct_debit_from',
  paymentagreements_from_account_field_label:
    'paymentagreements_from_account_field_label',
  paymentagreements_direct_debit_agreement_details_panel_title:
    'paymentagreements_direct_debit_agreement_details_panel_title',
  paymentagreements_direct_debit_agreement_details_cid:
    'paymentagreements_direct_debit_agreement_details_cid',
  paymentagreements_direct_debit_agreement_details_debit_account_number:
    'paymentagreements_direct_debit_agreement_details_debit_account_number',
  paymentagreements_direct_debit_agreement_details_account_owner:
    'paymentagreements_direct_debit_agreement_details_account_owner',
  paymentagreements_direct_debit_agreement_details_note:
    'paymentagreements_direct_debit_agreement_details_note',
  paymentagreements_direct_debit_agreement_details_edit_button:
    'paymentagreements_direct_debit_agreement_details_edit_button',
  paymentagreements_direct_debit_agreement_details_more_options_button:
    'paymentagreements_direct_debit_agreement_details_more_options_button',
  paymentagreements_direct_debit_agreement_details_delete_button:
    'paymentagreements_direct_debit_agreement_details_delete_button',
  paymentagreements_direct_debit_agreement_details_reactivate_button:
    'paymentagreements_direct_debit_agreement_details_reactivate_button',
  paymentagreements_direct_debit_agreement_details_stop_button:
    'paymentagreements_direct_debit_agreement_details_stop_button',
  paymentagreements_direct_debit_agreement_details_notification_title:
    'paymentagreements_direct_debit_agreement_details_notification_title',
  paymentagreements_direct_debit_agreement_details_notification_subtitle:
    'paymentagreements_direct_debit_agreement_details_notification_subtitle',
  paymentagreements_direct_debit_agreement_list_fetch_error_title:
    'paymentagreements_direct_debit_agreement_list_fetch_error_title',
  paymentagreements_direct_debit_agreement_details_delete_confirm_box_description:
    'paymentagreements_direct_debit_agreement_details_delete_confirm_box_description',
  paymentagreements_direct_debit_agreement_details_delete_confirm_box_title:
    'paymentagreements_direct_debit_agreement_details_delete_confirm_box_title',
  paymentagreements_direct_debit_error_feed_back_try_again_button:
    'paymentagreements_direct_debit_error_feed_back_try_again_button',
  paymentagreements_direct_debit_agreement_details_debit_account_owner_name:
    'paymentagreements_direct_debit_agreement_details_debit_account_owner_name',
  paymentagreements_einvoice_my_info_reference_id_subtitle:
    'paymentagreements_einvoice_my_info_reference_id_subtitle',
  paymentagreements_einvoice_fetch_customer_info_error:
    'paymentagreements_einvoice_fetch_customer_info_error',
  paymentagreements_einvoice_fetch_customer_info_error_message:
    'paymentagreements_einvoice_fetch_customer_info_error_message',
  paymentagreements_einvoice_notifications_title:
    'paymentagreements_einvoice_notifications_title',
  paymentagreements_einvoice_notifications_subtitle:
    'paymentagreements_einvoice_notifications_subtitle',
  paymentagreements_einvoice_push_notifications_cell_title:
    'paymentagreements_einvoice_push_notifications_cell_title',
  paymentagreements_einvoice_push_notifications_cell_subtitle:
    'paymentagreements_einvoice_push_notifications_cell_subtitle',
  paymentagreements_einvoice_notifications_send_email_alerts:
    'paymentagreements_einvoice_notifications_send_email_alerts',
  paymentagreements_einvoice_notifications_send_sms_alerts:
    'paymentagreements_einvoice_notifications_send_sms_alerts',
  paymentagreements_einvoice_notifications_send_sms_alerts_info:
    'paymentagreements_einvoice_notifications_send_sms_alerts_info',
  paymentagreements_einvoice_notifications_save_button:
    'paymentagreements_einvoice_notifications_save_button',
  paymentagreements_einvoice_notifications_your_profile_address_url:
    'paymentagreements_einvoice_notifications_your_profile_address_url',
  paymentagreements_einvoice_fetch_notification_settings_error:
    'paymentagreements_einvoice_fetch_notification_settings_error',
  paymentagreements_einvoice_fetch_notification_settings_error_message:
    'paymentagreements_einvoice_fetch_notification_settings_error_message',
  paymentagreements_einvoice_my_info_phone_and_email_missing_message:
    'paymentagreements_einvoice_my_info_phone_and_email_missing_message',
  paymentagreements_einvoice_my_info_phone_missing_message:
    'paymentagreements_einvoice_my_info_phone_missing_message',
  paymentagreements_einvoice_my_info_email_missing_message:
    'paymentagreements_einvoice_my_info_email_missing_message',
  paymentagreements_einvoice_notifications_off_text:
    'paymentagreements_einvoice_notifications_off_text',
  paymentagreements_einvoice_notifications_on_text:
    'paymentagreements_einvoice_notifications_on_text',
  paymentagreements_einvoice_notifications_send_sms_alerts_warning:
    'paymentagreements_einvoice_notifications_send_sms_alerts_warning',
  paymentagreements_einvoice_notifications_send_email_alerts_warning:
    'paymentagreements_einvoice_notifications_send_email_alerts_warning',
  paymentagreements_einvoice_notifications_save_error_feedback_title:
    'paymentagreements_einvoice_notifications_save_error_feedback_title',
  paymentagreements_einvoice_notifications_save_error_feedback_subtitle:
    'paymentagreements_einvoice_notifications_save_error_feedback_subtitle',
  paymentagreements_einvoice_notifications_save_error_feedback_cancel_button:
    'paymentagreements_einvoice_notifications_save_error_feedback_cancel_button',
  paymentagreements_einvoice_notifications_save_error_feedback_try_again_button:
    'paymentagreements_einvoice_notifications_save_error_feedback_try_again_button',
  paymentagreements_einvoice_notifications_save_success_message:
    'paymentagreements_einvoice_notifications_save_success_message',
  paymentagreements_einvoice_notifications_email_is_required:
    'paymentagreements_einvoice_notifications_email_is_required',
  paymentagreements_einvoice_my_info_email_exists:
    'paymentagreements_einvoice_my_info_email_exists',
  paymentagreements_einvoice_my_info_mobile_number_exists:
    'paymentagreements_einvoice_my_info_mobile_number_exists',
  paymentagreements_einvoice_my_info_save_error_feedback_title:
    'paymentagreements_einvoice_my_info_save_error_feedback_title',
  paymentagreements_einvoice_my_info_save_error_feedback_subtitle:
    'paymentagreements_einvoice_my_info_save_error_feedback_subtitle',
  paymentagreements_einvoice_my_info_save_error_feedback_try_again_button:
    'paymentagreements_einvoice_my_info_save_error_feedback_try_again_button',
  paymentagreements_einvoice_forward_section_subtitle:
    'paymentagreements_einvoice_forward_section_subtitle',
  paymentagreements_email_selector_input_title:
    'paymentagreements_email_selector_input_title',
  paymentagreements_einvoice_my_info_contact_phone_info_text:
    'paymentagreements_einvoice_my_info_contact_phone_info_text',
  paymentagreements_einvoice_process_from_other_banks_info_section_title:
    'paymentagreements_einvoice_process_from_other_banks_info_section_title',
  paymentagreements_einvoice_process_from_other_banks_info_section_content_text:
    'paymentagreements_einvoice_process_from_other_banks_info_section_content_text',
  paymentagreements_einvoice_authorize_info_section_title:
    'paymentagreements_einvoice_authorize_info_section_title',
  paymentagreements_einvoice_authorize_info_section_content_text:
    'paymentagreements_einvoice_authorize_info_section_content_text',
  paymentagreements_einvoice_reservation_against_company_info_section_title:
    'paymentagreements_einvoice_reservation_against_company_info_section_title',
  paymentagreements_einvoice_reservation_against_company_info_section_content_text:
    'paymentagreements_einvoice_reservation_against_company_info_section_content_text',
  paymentagreements_einvoice_general_info_personal_data_section_title:
    'paymentagreements_einvoice_general_info_personal_data_section_title',
  paymentagreements_einvoice_general_info_personal_data_section_content_first_text:
    'paymentagreements_einvoice_general_info_personal_data_section_content_first_text',
  paymentagreements_einvoice_general_info_personal_data_section_content_second_text:
    'paymentagreements_einvoice_general_info_personal_data_section_content_second_text',
  paymentagreements_einvoice_general_info_personal_data_section_content_last_text:
    'paymentagreements_einvoice_general_info_personal_data_section_content_last_text',
  paymentagreements_einvoice_general_info_personal_data_accordian_header:
    'paymentagreements_einvoice_general_info_personal_data_accordian_header',
  paymentagreements_einvoice_general_info_personal_data_accordian_content:
    'paymentagreements_einvoice_general_info_personal_data_accordian_content',
};

Object.freeze(translationKeys);

export default translationKeys;
